"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("modules/dom");
require("./tab-container-block.scss");
(0, dom_1.documentHasElements)(".js-tab-container-block", function (tabContainerBlocks) {
    tabContainerBlocks.forEach(function (tabContainerBlock) {
        var blocks = tabContainerBlock.querySelectorAll(".tab-blocks > div");
        var tabs = tabContainerBlock.querySelector(".tab-list");
        blocks.forEach(function (block, index) {
            block.setAttribute("data-item", index.toString());
            var listItem = document.createElement("li");
            var blockId = block.getAttribute("id");
            listItem.setAttribute("data-item", index.toString());
            if (blockId !== null) {
                listItem.innerHTML = blockId.toString();
            }
            if (listItem && tabs) {
                tabs.appendChild(listItem);
            }
        });
        var tabButtons = tabContainerBlock.querySelectorAll(".tab-list li");
        tabButtons[0].classList.add('active');
        blocks[0].classList.add('active');
        tabButtons.forEach(function (tab) {
            tab.addEventListener("click", function () {
                var isActive = tab.classList.contains("active");
                var tabId = tab.getAttribute("data-item");
                var tabContent = document.querySelectorAll("div[data-item=\"".concat(tabId, "\"]"));
                if (isActive) {
                    return;
                }
                tabButtons.forEach(function (otherTab) { return otherTab.classList.remove("active"); });
                blocks.forEach(function (block) { return block.classList.remove('active'); });
                if (!isActive) {
                    tab.classList.add("active");
                    tabContent[0].classList.add('active');
                }
            });
        });
    });
});
